import React, { Component } from "react";
import Logout from "../assets/logout.svg";
import Back from "../assets/back.svg";
// import Edit from '../assets/edit.svg'
import Plus from "../assets/plus.svg";
import EditButton from "../components/UsersEditButton";
import { AgGridReact } from "ag-grid-react";
import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-alpine.css";
// import { NumericFormat } from "react-number-format";
import { NumericFormat, PatternFormat } from "react-number-format";
import CustomButton from "../components/CustomButton";
import BootstrapSwitchButton from "bootstrap-switch-button-react";
import { Modal, Form } from "react-bootstrap";
import Cancel from "../assets/cancel.svg";
import Tick from "../assets/tick.svg";
import { WhisperSpinner } from "react-spinners-kit";
import { toast } from "react-toastify";
import Paginator from "../components/Paginator";
import PrinterItem from "../components/PrinterItem";
import filter from "../assets/filter.png";
import { Icon } from "@iconify/react";
import generator from "generate-password";
import refresh02 from "@iconify/icons-ci/refresh-02";
import momentjalali from "moment-jalaali";
import moment from "moment-timezone";
import Loading from "../components/Loading";
import {
  BaseUrl,
  Authorization,
  isUser,
  LogoutFunction,
  BaseUrlPublic,
  ServerSocket,
} from "../static.js";
import Tooltip from "@mui/material/Tooltip";
import warning from "../images/warning.png";
// import { OverlayTrigger, Tooltip } from "react-bootstrap";
import ListViewer from "../components/ListViewer";

const mobileRegex = RegExp(/09(0[0-9]|1[1-9]|2[1-9]|3[0-9]|9[0-9])-?[0-9]{7}/);

export default class Setting extends Component {
  constructor(props) {
    super(props);

    this.state = {
      gridLocaleText: {
        selectAll: "انتخاب همه",
        selectAllSearchResults: "انتخاب همه نتایج جستجو",
        searchOoo: "جستجو...",
        blanks: "خالی",
        noMatches: "پشدا نشد",
        filterOoo: "فیلتر...",
        equals: "مساوی",
        notEqual: "نا مساوی",
        lessThan: "کمتر از",
        greaterThan: "بیشتر از",
        lessThanOrEqual: "کوچکتر مساوی",
        greaterThanOrEqual: "بزرگتر مساوی",
        inRange: "در محدوده",
        inRangeStart: "به",
        inRangeEnd: "از",
        contains: "شامل",
        notContains: "شامل نباشد",
        startsWith: "شروع با",
        endsWith: "پایان با",
        andCondition: "و",
        orCondition: "یا",
        applyFilter: "تایید",
        resetFilter: "راه اندازی مجدد",
        clearFilter: "پاک کردن",
        cancelFilter: "انصراف",
        columns: "ستون ها",
        filters: "فیلترها",
        group: "گروه",
        loadingOoo: "لطفاً شکیبا باشید...",
        noRowsToShow: "هیچ موردی یافت نشد",
        enabled: "فعال",
        sum: "جمع",
        min: "کمترین",
        max: "بیشترین",
        none: "None",
        count: "تعداد",
        avg: "میانگین",
        filteredRows: "فیلتر شده",
        selectedRows: "انتخاب شده",
        totalRows: "جمع ردیف ها",
        totalAndFilteredRows: "ردیف ها",
        page: "صفحه",
        more: "بیشتر",
        to: "تا",
        of: "از",
        next: "بعدی",
        last: "آخرین",
        first: "اولین",
        previous: "قبلی",
      },
      rowData: [],
      columnDefs: [
        {
          headerName: "نام کاربری",
          field: "userName",
          sortable: true,
          filter: false,
          resizable: false,
          cellStyle: {
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            borderStyle: "solid",
            borderWidth: "0px 0px 0px 1px",
            borderColor: "var(--gray1)",
          },
          lockPosition: true,
        },
        {
          headerName: "نام و نام خانوادگی",
          field: "fullName",
          cellRenderer: "formatString",
          sortable: true,
          filter: false,
          resizable: false,
          cellStyle: {
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            borderStyle: "solid",
            borderWidth: "0px 0px 0px 1px",
            borderColor: "var(--gray1)",
          },
          lockPosition: true,
        },
        {
          headerName: "تلفن همراه",
          field: "mobile",
          cellRenderer: "formatString",
          sortable: true,
          filter: false,
          resizable: false,
          cellStyle: {
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            borderStyle: "solid",
            borderWidth: "0px 0px 0px 1px",
            borderColor: "var(--gray1)",
          },
          lockPosition: true,
        },
        {
          headerName: "تاریخ",
          field: "createdAt",
          cellRenderer: "formatDateTime",
          sortable: true,
          filter: false,
          resizable: false,
          cellStyle: {
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            borderStyle: "solid",
            borderWidth: "0px 0px 0px 1px",
            borderColor: "var(--gray1)",
          },
          lockPosition: true,
        },
        {
          headerName: "عملیات",
          field: "id",
          cellRenderer: "fotmatEditCell",
          // cellRendererParams: {
          //   editItem: this.editItem.bind(this),
          //   deleteItem: this.deleteItem.bind(this),
          // },
          sortable: true,
          filter: false,
          resizable: false,
          cellStyle: {
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            borderStyle: "solid",
            borderWidth: "0px 0px 0px 1px",
            borderColor: "var(--gray1)",
          },
          lockPosition: true,
        },
      ],
      frameworkComponents: {
        fotmatEditCell: EditButton,
        formatCurrency: this.formatCurrency,
        formatNumber: this.formatNumber,
        formatString: this.formatString,
        formatDateTime: this.formatDateTime,
      },
      ModalShow: false,
      modalType: 0,
      writingProgress: false,
      fullNameErrorText: "",
      fullNameValue: "",
      userNameErrorText: "",
      userNameValue: "",
      mobileErrorText: "",
      mobileValue: "",
      passwordErrorText: "",
      passwordValue: "sepandplus12345",
      activeStatus: true,
      fPurchaseErrorText: "",
      fPurchaseValue: "",
      tPurchaseErrorText: "",
      tPurchaseValue: "",
      downgrade: false,
      dataLoading: true,
      currentPage: 1,
      totalPages: 1,
      ModalShow1: false,
      modal1Loading: false,
      AccessModal: false,
      currentPage1: 0,
      totalPages1: 0,
      ModalShow2: false,
      CNameErrorText: "",
      CNameValue: "",
      CPhoneErrorText: "",
      CPhoneValue: "",
      writingProgress1: false,
      currentGroupId: null,
      tableHasFilter: false,
      accessList: [],
      passwordGenerated: false,
      currentUserAccess: [],
      deleteModalShow: false,
      currentDeleteItemName: "",
      currentDeleteItemId: null,
      orderProcess: [],
      selectedOrderProcess: [],
      orderProcessId: [],
      ModalShowOrderProcess: false,

      taxErrorText: "",
      taxValue: "",
      taxFixed: false,
      serviceErrorText: "",
      serviceValue: "",
      packing: false,
      packingFixed: false,
      fixedPriceErrorText: "",
      fixedPriceValue: 0,
      tax: false,
      service: false,
      currentListTypeIsTax: false,
      taxSelected: [],
      packingSelected: [],
      currentList: [],
      listLoading: false,
      defaultLangId: 0,
      resID: 0,
      rtlPriceTitle: "ریال",
      totalMenuCount: 0,
      sendInvoiceToCustomer: false,
      onlinePayment: false,
      shebaErrorText: "",
      shebaValue: "",
      printerModal: false,
      allPrinterList: [],
      getPrintersLoading: false,
      retrievePrinterListLoading: false,
      token: "",
      printerHelperAddress: "",
    };

    this.tableGrid = React.createRef();
    this.tableContainer = React.createRef();

    this.readSetting = this.readSetting.bind(this);
    this.getMenu = this.getMenu.bind(this);

    this.getPrinterFromPCTimeOut = undefined;
  }

  formatDateTime(params) {
    try {
      if (
        params.value === "null" ||
        params.value === "" ||
        params.value === 0 ||
        params.value === null
      )
        return "-";
      var zone_name = moment.tz.guess();
      let newdatetime = moment
        .tz(params.value, zone_name)
        .format("yyyy-MM-DD HH:mm")
        .toString()
        .split(" ");

      let result =
        newdatetime[1] +
        " " +
        momentjalali(newdatetime[0]).format("jYYYY/jMM/jDD");

      return result;
    } catch (error) {
      return "-";
    }
  }

  formatString(params) {
    try {
      if (
        params.value === "null" ||
        params.value === "" ||
        params.value === 0 ||
        params.value === null
      )
        return "-";
      return params.value;
    } catch (error) {
      return "-";
    }
  }

  formatNumber(params) {
    try {
      if (
        params.value === "null" ||
        params.value === "" ||
        params.value === 0 ||
        params.value === null
      )
        return "0";
      return (
        <NumericFormat
          value={params.value}
          displayType={"text"}
          thousandSeparator={true}
        />
      );
    } catch (error) {
      return "-";
    }
  }

  formatCurrency(params) {
    try {
      if (
        params.value === "null" ||
        params.value === "" ||
        params.value === 0 ||
        params.value === null
      )
        return "-";
      return (
        <NumericFormat
          value={params.value}
          displayType={"text"}
          thousandSeparator={true}
          suffix={" " + this.state.rtlPriceTitle}
        />
      );
    } catch (error) {
      return "-";
    }
  }

  componentDidMount() {
    this.findBusinessWithCode();

    ServerSocket.on("retrievePrinterListFromPC", (data) => {
      console.log("retrievePrinterListFromPC: ", data);
      let printerList = [];
      if (data && data.priterList)
        data.priterList.forEach((element) => {
          let found = false;
          this.state.allPrinterList.forEach((element1) => {
            if (element1.title === element) {
              found = true;
              printerList.push(element1);
            }
          });

          if (!found)
            printerList.push({
              title: element,
              label: "",
              selected: false,
              registered: false,
              forCashier: false,
            });
        });

      clearTimeout(this.getPrinterFromPCTimeOut);
      this.setState({
        allPrinterList: printerList,
        retrievePrinterListLoading: false,
      });
    });
  }

  findBusinessWithCode() {
    let data = {
      businessCode: this.props.match.params.id,
    };
    fetch(BaseUrlPublic + "findBusinessWithCode", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(data),
    })
      .then((res) => res.json())
      .then((result) => {
        console.log(result);
        if (result.status === 200) {
          let defaultLangId = 0;
          result.info.forEach((element) => {
            if (element.languageId === 1) {
              defaultLangId = element.languageId;
            }
          });

          if (defaultLangId === 0) {
            result.info.forEach((element) => {
              if (element.languageId === result.result[0].defaultLanguage) {
                defaultLangId = element.languageId;
              }
            });
          }

          if (defaultLangId === 0) {
            result.info.forEach((element) => {
              if (defaultLangId === 0) {
                defaultLangId = element.languageId;
              }
            });
          }

          this.setState(
            {
              // dataLoading: false,
              resID: result.result[0].id,
              defaultLangId: defaultLangId,
              rtlPriceTitle: result.result[0].rtlPriceTitle,
            },
            () => {
              this.readSetting();
            }
          );
        } else if (result.status === 401) {
          LogoutFunction();
        } else {
          this.props.goToBusinessList();
        }
        console.log("findBusinessWithCode:", result);
      })
      .catch((err) => {
        console.log(err);
      });
  }

  readSetting() {
    let data = {
      businessId: this.state.resID,
      businessCode: this.props.match.params.id,
    };
    data = Object.assign(data, Authorization());

    // this.setState({
    //   loadingSetting: true,
    //   ModalShow: true,
    //   modalType: "setting",
    // });

    fetch(BaseUrl + "readBusinessSettings", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(data),
    })
      .then((res) => res.json())
      .then((result) => {
        console.log("====================================");
        console.log("readBusinessSettings: ", result);
        console.log("====================================");
        let taxlist = result.tax;
        taxlist.forEach((element) => {
          element.selected = true;
        });
        let packlist = result.packing;
        packlist.forEach((element) => {
          element.selected = true;
        });
        this.setState({
          tax: result.result[0].tax === "none" ? false : true,
          packing: result.result[0].packing === "none" ? false : true,
          packingFixed: result.result[0].packing === "fixed" ? true : false,
          fixedPriceValue: result.result[0].packingFixedValue,
          service: result.result[0].servicePercent > 0 ? true : false,
          serviceValue: result.result[0].servicePercent,
          taxSelected: result.result[0].tax !== "none" ? taxlist : [],
          packingSelected: result.result[0].packing !== "none" ? packlist : [],
          sendInvoiceToCustomer: result.result[0].sendInvoiceToCustomer
            ? true
            : false,
          onlinePayment: result.result[0].onlinePayment === 1 ? true : false,
          shebaValue: result.result[0].bankAccount
            ?.replace("IR", "")
            .replace("ir", ""),
          token: result.result[0].token,
          printerHelperAddress: result.printerHelperAddress,
        });
        this.getMenu();
        // if (result.status === 200) {
        //   if (result.result[0].tax === "none") this.setState({ tax: false });
        //   else {
        //     let cat = [];
        //     result.tax.forEach((element) => {
        //       cat.push(element.id);
        //     });
        //     this.setState({
        //       tax: true,
        //       taxValue: result.result[0].taxPercent,
        //       groupList1: cat,
        //     });
        //     console.log(cat);
        //   }

        //   if (result.result[0].service === "none")
        //     this.setState({ service: false });
        //   else {
        //     this.setState({
        //       service: true,
        //       serviceValue: result.result[0].servicePercent,
        //     });
        //   }

        //   if (result.result[0].packing === "none")
        //     this.setState({ packing: false });
        //   else if (result.result[0].packing === "basedOnCategory") {
        //     let cat = [];
        //     result.packing.forEach((element) => {
        //       if (element.packingPrice > 0)
        //         cat.push({
        //           categoryId: element.id,
        //           packingPrice: Number(element.packingPrice),
        //         });
        //     });

        //     this.setState({
        //       packing: true,
        //       packingFixed: false,
        //       groupList2: cat,
        //     });
        //     console.log(cat);
        //   } else {
        //     this.setState({
        //       packing: true,
        //       packingFixed: true,
        //       fixedPriceValue: result.result[0].packingFixedValue,
        //     });
        //   }

        //   this.setState({ loadingSetting: false });
        // } else if (result.status === 401) {
        //   LogoutFunction();
        // }
      })
      .catch((err) => {
        console.log(err);
      });
  }

  // readOrderProcess() {
  //   let data = {
  //     businessCode: this.props.match.params.id,
  //   };
  //   data = Object.assign(data, Authorization());

  //   fetch(BaseUrl + "readOrderProcess", {
  //     method: "POST",
  //     headers: { "Content-Type": "application/json" },
  //     body: JSON.stringify(data),
  //   })
  //     .then((res) => res.json())
  //     .then((result) => {
  //       console.log("readOrderProcess:", result);
  //       if (result.status === 200) {
  //         this.setState({
  //           dataLoading: false,
  //           orderProcess: result.result,
  //         });
  //       } else {
  //         toast.error(result.message, {
  //           position: toast.POSITION.BOTTOM_RIGHT,
  //           hideProgressBar: true,
  //           autoClose: 6000,
  //           toastClassName: "toast",
  //         });
  //       }
  //     })
  //     .catch((err) => {
  //       console.log(err);
  //     });
  // }

  getMenu() {
    let data = {
      languageId: this.state.defaultLangId,
      type: "getMenuWithBusinessCode",
      businessCode: this.props.match.params.id,
    };
    data = Object.assign(data, Authorization());

    // console.log(data);

    fetch(BaseUrl + "getMenu", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(data),
    })
      .then((res) => res.json())
      .then((result) => {
        console.log("getMenuuuuuu:", result);
        let menu = [...result.result];
        let itemsCount = 0;
        // let menucat = [];

        menu.forEach((element) => {
          itemsCount += element.items.length;
          element.nameObj.forEach((element1) => {
            if (element1.languageId === 1) {
              element.name = element1.name;
            } else if (element1.languageId === this.state.defaultLangId) {
              element.name = element1.name;
            } else {
              element.name = element1.name;
            }
          });

          element.items.forEach((element1) => {
            element1.nameObj.forEach((element2) => {
              if (element2.languageId === 1) {
                element1.name = element2.name;
              } else if (element2.languageId === this.state.defaultLangId) {
                element1.name = element2.name;
              } else {
                element1.name = element2.name;
              }
            });
          });
        });

        // for (let i = menu.length - 1; i >= 0; i--) {
        //   menu[i].nameObj.forEach((element) => {
        //     if (element.languageId === 1) {
        //       menu[i].name = element.name;
        //     }

        //     if (
        //       !menu[i].name &&
        //       element.languageId === this.state.defaultLangId
        //     ) {
        //       menu[i].name = element.name;
        //     }

        //     if (!menu[i].name) {
        //       menu[i].name = element.name;
        //     }
        //   });

        //   menucat.push(menu[i]);
        // }

        // console.log(menucat);

        this.setState({
          dataLoading: false,
          currentList: menu,
          totalMenuCount: itemsCount,
        });
      })
      .catch((err) => {
        console.log(err);
      });
  }

  // readBusinessUserTypeList(id) {
  //   let data = {
  //     businessCode: this.props.match.params.id,
  //   };
  //   data = Object.assign(data, Authorization());

  //   fetch(BaseUrl + "readBusinessUserTypeList", {
  //     method: "POST",
  //     headers: { "Content-Type": "application/json" },
  //     body: JSON.stringify(data),
  //   })
  //     .then((res) => res.json())
  //     .then((result) => {
  //       console.log(result);
  //       if (result.status === 200) {
  //         this.setState(
  //           {
  //             accessList: result.ruleList,
  //           },
  //           () => {
  //             if (id !== 0) this.getUserInfo(id);
  //           }
  //         );
  //       } else if (result.status === 401) {
  //         LogoutFunction();
  //       }
  //     })
  //     .catch((err) => {
  //       console.log(err);
  //     });
  // }

  // getUserInfo(id) {
  //   let data = {
  //     businessCode: this.props.match.params.id,
  //     businessUserId: id,
  //   };
  //   data = Object.assign(data, Authorization());

  //   fetch(BaseUrl + "getUserInfo", {
  //     method: "POST",
  //     headers: { "Content-Type": "application/json" },
  //     body: JSON.stringify(data),
  //   })
  //     .then((res) => res.json())
  //     .then((result) => {
  //       console.log(result);
  //       if (result.status === 200) {
  //         let access = JSON.parse(JSON.stringify(this.state.accessList));

  //         result.userInfo.userType.forEach((element) => {
  //           access.forEach((element1) => {
  //             if (element1.id === element.typeId) {
  //               element1.value = true;

  //               element.typeOptions.forEach((element3) => {
  //                 element1.options.forEach((element2) => {
  //                   if (element2.id === element3) {
  //                     element2.value = true;
  //                   }
  //                 });
  //               });
  //             }
  //           });
  //         });

  //         this.setState({
  //           accessList: access,
  //           currentUserAccess: result.userInfo.userType,
  //         });
  //         // this.setState({
  //         //   accessList: result.ruleList,
  //         // });
  //       } else if (result.status === 401) {
  //         LogoutFunction();
  //       }
  //     })
  //     .catch((err) => {
  //       console.log(err);
  //     });
  // }

  onFirstPageClick() {
    this.readBusinessUserList(1);
  }

  onPreviousPageClick() {
    this.readBusinessUserList(this.state.currentPage - 1);
  }

  onNextPageClick() {
    this.readBusinessUserList(this.state.currentPage + 1);
  }

  onLastPageClick() {
    this.readBusinessUserList(this.state.totalPages);
  }

  onBack() {
    this.props.history.push("/Restaurants/" + this.props.match.params.id);
  }

  onLogout() {
    LogoutFunction();
  }

  onFirstDataRendered(params) {
    try {
      params.api.sizeColumnsToFit();
      window.setTimeout(() => {
        const colIds = params.columnApi.getAllColumns().map((c) => c.colId);
        params.columnApi.autoSizeColumns(colIds, false);

        let cols = this.tableGrid.current.columnApi.getColumnState();
        let width = 0;
        cols.forEach((element) => {
          width += element.width;
        });

        // console.log('width',width);
        // console.log('tableContainer',this.tableContainer.current.getBoundingClientRect().width-10);
        if (
          width <
          this.tableContainer.current.getBoundingClientRect().width - 10
        ) {
          let def =
            this.tableContainer.current.getBoundingClientRect().width -
            10 -
            width;
          // console.log('def',def);
          if (def > cols.length) {
            let newwidth = def / cols.length;
            // console.log('newwidth',newwidth)
            cols.forEach((element) => {
              params.columnApi.setColumnWidth(
                element.colId,
                element.width + newwidth
              );
            });
          } else {
            // console.log('aa');
            params.columnApi.setColumnWidth(cols[0].colId, cols[0].width + def);
          }
        }
        // if (width<this.tableContainer.current.getBoundingClientRect().width) params.api.sizeColumnsToFit()
      }, 50);
    } catch (error) {}
  }

  onSelectCategory1() {
    this.setState(
      {
        ModalShow2: true,
        // listLoading: true,
        currentListTypeIsTax: true,
        // currentList: [],
      },
      () => {
        // this.getMenu();
      }
    );
  }

  onSelectCategory2() {
    this.setState({
      ModalShow2: true,
      currentListTypeIsTax: false,
    });
  }

  onConfirmProduct(list) {
    console.log(list);
    console.log("currentlist: ", this.state.currentList);
    if (this.state.currentListTypeIsTax) {
      // let item = [];
      // list.forEach((element) => {
      //   item.push({
      //     foodId: element.id,
      //     taxPercent: Number(element.taxPercent),
      //   });
      // });
      this.setState({ taxSelected: list, ModalShow2: false });
    } else {
      // let item = [];
      // list.forEach((element) => {
      //   item.push({
      //     foodId: element.id,
      //     packingPrice: Number(element.packingPrice),
      //   });
      // });
      this.setState({ packingSelected: list, ModalShow2: false });
    }
  }

  onSaveFinance() {
    let tax = "none";
    let taxValue = 0;
    let taxFood = [];
    let service = "none";
    let serviceValue = 0;
    let packing = "none";
    let packingFixed = false;
    let packingValue = 0;
    let packingFood = [];

    this.setState({
      taxErrorText: "",
      serviceErrorText: "",
      fixedPriceErrorText: "",
    });

    if (this.state.tax) {
      // if (
      //   this.state.taxFixed &&
      //   (!this.state.taxValue || this.state.taxValue < 1)
      // ) {
      //   this.setState({ taxErrorText: "درصد مالیات نادرست است" });
      //   toast.error("درصد مالیات نادرست است", {
      //     position: toast.POSITION.BOTTOM_RIGHT,
      //     hideProgressBar: true,
      //     autoClose: 8000,
      //     toastClassName: "toast",
      //   });
      //   return;
      // }

      if (!this.state.taxFixed && this.state.taxSelected.length === 0) {
        toast.error("غذایی که شامل مالیات می‌شوند را انتخاب کنید", {
          position: toast.POSITION.BOTTOM_RIGHT,
          hideProgressBar: true,
          autoClose: 8000,
          toastClassName: "toast",
        });
        return;
      }

      let taxList = [];
      this.state.taxSelected.forEach((element) => {
        taxList.push({
          foodId: element.id,
          taxPercent: element.taxPercent,
        });
      });

      // taxValue = this.state.taxValue;
      tax = "basedOnFood";
      taxFood = taxList;
    }

    if (this.state.service) {
      if (!this.state.serviceValue || this.state.serviceValue < 1) {
        this.setState({ serviceErrorText: "درصد حق سرویس نادرست است" });
        toast.error("درصد حق سرویس نادرست است", {
          position: toast.POSITION.BOTTOM_RIGHT,
          hideProgressBar: true,
          autoClose: 8000,
          toastClassName: "toast",
        });
        return;
      }

      service = "basedOnInvoice";
      serviceValue = this.state.serviceValue;
    }

    if (this.state.packing) {
      if (this.state.packingFixed) {
        if (!this.state.fixedPriceValue || this.state.fixedPriceValue < 1) {
          this.setState({ fixedPriceErrorText: "مبلغ بسته‌بندی نادرست است" });
          toast.error("مبلغ بسته‌بندی نادرست است", {
            position: toast.POSITION.BOTTOM_RIGHT,
            hideProgressBar: true,
            autoClose: 8000,
            toastClassName: "toast",
          });
          return;
        }

        packing = "fixed";
        packingValue = this.state.fixedPriceValue;
      } else {
        if (this.state.packingSelected.length === 0) {
          toast.error(
            "گروه‌های غذایی که شامل هزینه بسته‌بندی می‌شوند را انتخاب کنید",
            {
              position: toast.POSITION.BOTTOM_RIGHT,
              hideProgressBar: true,
              autoClose: 8000,
              toastClassName: "toast",
            }
          );
          return;
        }

        packing = "basedOnFood";

        let packList = [];
        this.state.packingSelected.forEach((element) => {
          packList.push({
            foodId: element.id,
            packingPrice: element.packingPrice,
          });
        });

        packingFood = packList;
      }
    }

    let data = {
      businessId: this.state.resID,
      businessCode: this.props.match.params.id,
      tax: tax,
      service: service,
      servicePercent: serviceValue,
      packing: packing,
      packingFixedValue: packingValue,
      taxFood: taxFood,
      packingPriceArray: packingFood,
      sendInvoiceToCustomer: this.state.sendInvoiceToCustomer,
      onlinePayment: this.state.onlinePayment,
      bankAccount: this.state.onlinePayment
        ? "IR" + this.state.shebaValue
        : null,
    };
    data = Object.assign(data, Authorization());
    console.log(data);
    // return;
    this.setState({ writingSetting: true });

    fetch(BaseUrl + "editBusinessSettings", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(data),
    })
      .then((res) => res.json())
      .then((result) => {
        this.setState({ writingSetting: false });
        if (result.status === 200) {
          toast.success("تنظیمات با موفقیت ذخیره شد", {
            position: toast.POSITION.BOTTOM_RIGHT,
            hideProgressBar: true,
            autoClose: 8000,
            toastClassName: "toast",
          });
          this.setState({ ModalShow: false });
        } else if (result.status === 401) {
          LogoutFunction();
        } else {
          toast.error(result.message, {
            position: toast.POSITION.BOTTOM_RIGHT,
            hideProgressBar: true,
            autoClose: 8000,
            toastClassName: "toast",
          });
        }
      })
      .catch((err) => {
        console.log(err);
      });
  }

  onAddNewGate() {}

  getPrinters() {
    let data = {
      businessCode: this.props.match.params.id,
    };
    data = Object.assign(data, Authorization());
    console.log(data);
    this.setState({ getPrintersLoading: true });

    fetch(BaseUrl + "getPrinters", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(data),
    })
      .then((res) => res.json())
      .then((result) => {
        console.log(result);
        this.setState({ getPrintersLoading: false });
        if (result.status === 200) {
          let pl = [];
          result.result.forEach((element) => {
            pl.push({
              id: element.id,
              title: element.printerName,
              label: element.label,
              selected: true,
              registered: true,
              forCashier: element.forCashier,
            });
          });
          this.setState({ allPrinterList: pl });
        } else if (result.status === 401) {
          LogoutFunction();
        } else {
          toast.error(result.message, {
            position: toast.POSITION.BOTTOM_RIGHT,
            hideProgressBar: true,
            autoClose: 8000,
            toastClassName: "toast",
          });
        }
      })
      .catch((err) => {
        console.log(err);
        this.setState({ getPrintersLoading: false });
      });
  }

  retrievePrinterList() {
    let data = {
      businessCode: this.props.match.params.id,
    };
    data = Object.assign(data, Authorization());
    console.log(data);
    this.setState({ retrievePrinterListLoading: true });

    fetch(BaseUrl + "retrievePrinterList", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(data),
    })
      .then((res) => res.json())
      .then((result) => {
        console.log(result);
        // this.setState({ retrievePrinterListLoading: false });
        if (result.status === 200) {
          this.getPrinterFromPCTimeOut = setTimeout(() => {
            this.setState({ retrievePrinterListLoading: false });
          }, 20000);
        } else if (result.status === 401) {
          LogoutFunction();
        } else {
          this.setState({ retrievePrinterListLoading: false });
          toast.error(result.message, {
            position: toast.POSITION.BOTTOM_RIGHT,
            hideProgressBar: true,
            autoClose: 8000,
            toastClassName: "toast",
          });
        }
      })
      .catch((err) => {
        this.setState({ retrievePrinterListLoading: false });
        console.log(err);
      });
  }

  changePrinterSelect(title) {
    let printers = JSON.parse(JSON.stringify(this.state.allPrinterList));
    printers.forEach((element) => {
      if (element.title === title) {
        if (element.selected) {
          element.forCashier = false;
        }
        element.selected = !element.selected;
      }
    });

    this.setState({ allPrinterList: printers });
  }

  changePrinterLabel(title, label) {
    let printers = JSON.parse(JSON.stringify(this.state.allPrinterList));
    printers.forEach((element) => {
      if (element.title === title) element.label = label;
    });

    this.setState({ allPrinterList: printers });
  }

  setPrinterForCashier(title) {
    let printers = JSON.parse(JSON.stringify(this.state.allPrinterList));
    printers.forEach((element) => {
      if (element.title === title) element.forCashier = true;
      else element.forCashier = false;
    });

    this.setState({ allPrinterList: printers });
  }

  onConfirmPrinters() {
    let pl = [];
    this.state.allPrinterList
      .filter((item) => item.selected)
      .forEach((element) => {
        pl.push({
          printerName: element.title,
          label: element.label,
          forCashier: element.forCashier,
        });
      });

    let unselectPL = [];
    this.state.allPrinterList
      .filter((item) => !item.selected && item.registered)
      .forEach((element) => {
        unselectPL.push(element.id);
      });

    let data = {
      businessCode: this.props.match.params.id,
      printerList: pl,
      unselectedPrinter: unselectPL,
    };
    data = Object.assign(data, Authorization());
    console.log(data);
    this.setState({ buttonLoading: true });

    fetch(BaseUrl + "addPrinterList", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(data),
    })
      .then((res) => res.json())
      .then((result) => {
        console.log(result);
        if (result.status === 200) {
          this.setState({ buttonLoading: false, printerModal: false });
        } else if (result.status === 401) {
          LogoutFunction();
        } else {
          toast.error(result.message, {
            position: toast.POSITION.BOTTOM_RIGHT,
            hideProgressBar: true,
            autoClose: 8000,
            toastClassName: "toast",
          });
        }
      })
      .catch((err) => {
        this.setState({ buttonLoading: false });
        console.log(err);
      });
  }

  render() {
    return (
      <div className="Login">
        <div className="header">
          <div
            onClick={this.onBack.bind(this)}
            className="linkStyle backButton"
          >
            <img
              src={Back}
              alt=""
              className="backButtonIcon"
              style={{ transform: "rotate(180deg)" }}
            />
            بازگشت
          </div>
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              height: "fit-content",
              alignItems: "center",
            }}
          >
            <Tooltip title="خروج">
              <div
                onClick={this.onLogout.bind(this)}
                className="linkStyle backButton"
                // data-tip="خروج"
                // data-place="bottom"
              >
                <img src={Logout} alt="" className="backButtonIcon" />
              </div>
            </Tooltip>
          </div>
        </div>
        <div className="LoginContent">
          <div className="RestaurantsListTitle">تنظیمات</div>
          {/* <div className="RestaurantsListSubTitle">
            ایجاد کابر جدید و اختصاص سطح دسترسی
          </div> */}
        </div>

        {!this.state.dataLoading && (
          <div className="reportContaner" style={{ height: "unset" }}>
            <div className="reportTitleBar">تنظیمات کلی</div>
            <div
              className="reportContent"
              style={{ paddingTop: "10px", paddingBottom: "10px" }}
            >
              <div
                className="pageContents"
                style={{ marginTop: "0px", height: "auto" }}
                // ref={this.tableContainer}
              >
                <div className="grid-setting">
                  <div
                    className="settingItemContainer"
                    style={{ display: "flex", flexDirection: "column" }}
                  >
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "row",
                        width: "100%",
                        justifyContent: "space-between",
                        alignItems: "center",
                      }}
                    >
                      <div
                        className="settingLabel"
                        style={{ fontSize: "12px", whiteSpace: "noWrap" }}
                      >
                        شناسه رستوران
                      </div>
                      <Form.Control
                        className="inputStyleForm"
                        style={{
                          // maxWidth: "300px",
                          direction: "ltr",
                        }}
                        type="text"
                        readOnly
                        // name="labelValue"
                        // onChange={this.textHandleChange.bind(this)}
                        value={this.state.token}
                      />
                    </div>
                  </div>

                  <div
                    style={{
                      width: "100%",
                      maxWidth: "250px",
                      // marginTop: "40px",
                      alignSelf: "center",
                    }}
                  >
                    <CustomButton
                      title="تنظیمات دستگاهای چاپ"
                      imgHeight={20}
                      imgWidth={25}
                      minHeight="35px"
                      // img={Tick}
                      loading={this.state.financeLoading}
                      onClick={() => {
                        this.setState({ printerModal: true }, () => {
                          this.getPrinters();
                        });
                      }}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}

        {!this.state.dataLoading && (
          <div
            className="reportContaner"
            style={{ marginBottom: "100px", height: "unset" }}
          >
            <div className="reportTitleBar">مالی</div>
            <div
              className="reportContent"
              style={{ paddingTop: "10px", paddingBottom: "10px" }}
            >
              <div
                className="pageContents"
                style={{ marginTop: "0px", height: "auto" }}
                ref={this.tableContainer}
              >
                <div className="grid-setting">
                  <div
                    className="settingItemContainer"
                    style={{ display: "flex", flexDirection: "column" }}
                  >
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "row",
                        width: "100%",
                        justifyContent: "space-between",
                        alignItems: "center",
                      }}
                    >
                      <div className="settingLabel">مالیات</div>
                      <BootstrapSwitchButton
                        checked={this.state.tax}
                        onChange={(checked) => {
                          this.setState({ tax: checked });
                        }}
                        onlabel="دارد"
                        offlabel="ندارد"
                        onstyle="primary"
                        offstyle="warning"
                        width={75}
                      />
                    </div>

                    {this.state.tax && (
                      <div style={{ width: "100%", marginTop: "13px" }}>
                        <CustomButton
                          title="انتخاب محصولات"
                          imgHeight={20}
                          imgWidth={25}
                          minHeight="35px"
                          onClick={this.onSelectCategory1.bind(this)}
                        />
                      </div>
                    )}
                  </div>
                  <div
                    className="settingItemContainer"
                    style={{ display: "flex", flexDirection: "column" }}
                  >
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "row",
                        width: "100%",
                        justifyContent: "space-between",
                        alignItems: "center",
                      }}
                    >
                      <div className="settingLabel">حق سرویس</div>
                      <BootstrapSwitchButton
                        checked={this.state.service}
                        onChange={(checked) => {
                          this.setState({ service: checked });
                        }}
                        onlabel="دارد"
                        offlabel="ندارد"
                        onstyle="primary"
                        offstyle="warning"
                        width={75}
                      />
                    </div>

                    {this.state.service && (
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "row",
                          width: "100%",
                          justifyContent: "space-between",
                          alignItems: "center",
                          marginTop: "10px",
                        }}
                      >
                        <div
                          className="settingLabel"
                          style={{ fontSize: "12px" }}
                        >
                          درصد حق سرویس
                        </div>
                        <NumericFormat
                          className={
                            this.state.serviceErrorText !== ""
                              ? "inputStyleForm inputError textAlignCenter form-control"
                              : "form-control inputStyleForm textAlignCenter"
                          }
                          style={{ maxWidth: "120px", direction: "ltr" }}
                          placeholder="درصد %"
                          type="text"
                          name="serviceValue"
                          suffix="%"
                          onValueChange={(values) => {
                            this.setState({ serviceValue: values.value });
                          }}
                          value={this.state.serviceValue}
                          allowNegative={true}
                          displayType={"input"}
                          thousandSeparator={true}
                        />
                      </div>
                    )}
                  </div>
                  <div
                    className="settingItemContainer"
                    style={{ display: "flex", flexDirection: "column" }}
                  >
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "row",
                        width: "100%",
                        justifyContent: "space-between",
                        alignItems: "center",
                      }}
                    >
                      <div className="settingLabel">بسته بندی</div>
                      <BootstrapSwitchButton
                        checked={this.state.packing}
                        onChange={(checked) => {
                          this.setState({ packing: checked });
                        }}
                        onlabel="دارد"
                        offlabel="ندارد"
                        onstyle="primary"
                        offstyle="warning"
                        width={75}
                      />
                    </div>

                    {this.state.packing && (
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "row",
                          width: "100%",
                          justifyContent: "space-between",
                          alignItems: "center",
                          marginTop: "10px",
                        }}
                      >
                        <div
                          className="settingLabel"
                          style={{ fontSize: "12px" }}
                        >
                          مبلغ ثابت روی فاکتور
                        </div>

                        <BootstrapSwitchButton
                          checked={this.state.packingFixed}
                          onChange={(checked) => {
                            this.setState({ packingFixed: checked });
                          }}
                          onlabel="بله"
                          offlabel="خیر"
                          onstyle="primary"
                          offstyle="warning"
                          width={75}
                        />
                      </div>
                    )}

                    {this.state.packingFixed && this.state.packing && (
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "row",
                          width: "100%",
                          justifyContent: "space-between",
                          alignItems: "center",
                          marginTop: "10px",
                        }}
                      >
                        <div
                          className="settingLabel"
                          style={{ fontSize: "12px" }}
                        >
                          {"مبلغ (" + this.state.rtlPriceTitle + ")"}
                        </div>

                        <NumericFormat
                          className={
                            this.state.fixedPriceErrorText !== ""
                              ? "inputStyleForm inputError textAlignCenter form-control"
                              : "form-control inputStyleForm textAlignCenter"
                          }
                          style={{ maxWidth: "120px", direction: "ltr" }}
                          placeholder={this.state.rtlPriceTitle}
                          type="text"
                          name="fixedPriceValue"
                          onValueChange={(values) => {
                            this.setState({
                              fixedPriceValue: values.value,
                            });
                          }}
                          value={this.state.fixedPriceValue}
                          allowNegative={true}
                          displayType={"input"}
                          thousandSeparator={true}
                        />
                      </div>
                    )}

                    {this.state.packing && !this.state.packingFixed && (
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "row",
                          width: "100%",
                          justifyContent: "space-between",
                          alignItems: "center",
                          marginTop: "13px",
                        }}
                      >
                        <div style={{ flex: "1" }}>
                          <CustomButton
                            title="انتخاب محصولات"
                            imgHeight={20}
                            imgWidth={25}
                            minHeight="35px"
                            onClick={this.onSelectCategory2.bind(this)}
                          />
                        </div>
                      </div>
                    )}
                  </div>

                  <div
                    className="settingItemContainer"
                    style={{ display: "flex", flexDirection: "column" }}
                  >
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "row",
                        width: "100%",
                        justifyContent: "space-between",
                        alignItems: "center",
                      }}
                    >
                      <div className="settingLabel">ارسال پیامک فاکتور</div>
                      <BootstrapSwitchButton
                        checked={this.state.sendInvoiceToCustomer}
                        onChange={(checked) => {
                          this.setState({ sendInvoiceToCustomer: checked });
                        }}
                        onlabel="بله"
                        offlabel="خیر"
                        onstyle="primary"
                        offstyle="warning"
                        width={75}
                      />
                    </div>
                  </div>

                  <div
                    className="settingItemContainer"
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      // height: "54px",
                    }}
                  >
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "row",
                        width: "100%",
                        justifyContent: "space-between",
                        alignItems: "center",
                      }}
                    >
                      <div className="settingLabel">پرداخت آنلاین</div>
                      <BootstrapSwitchButton
                        checked={this.state.onlinePayment}
                        onChange={(checked) => {
                          this.setState({ onlinePayment: checked });
                        }}
                        onlabel="فعال"
                        offlabel="غیرفعال"
                        onstyle="primary"
                        offstyle="warning"
                        width={75}
                      />
                    </div>
                  </div>

                  <div
                    className="settingItemContainer"
                    style={{ display: "flex", flexDirection: "column" }}
                  >
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "row",
                        width: "100%",
                        justifyContent: "space-between",
                        alignItems: "center",
                      }}
                    >
                      <div
                        className="settingLabel"
                        style={{ fontSize: "12px" }}
                      >
                        شماره شبا
                      </div>
                      <PatternFormat
                        format="IR ## #### #### #### #### #### ##"
                        allowEmptyFormatting
                        className={
                          this.state.shebaErrorText !== ""
                            ? "inputStyleForm inputError form-control textAlignLeft"
                            : "form-control inputStyleForm textAlignLeft"
                        }
                        style={{
                          maxWidth: "300px",
                          direction: "ltr",
                        }}
                        onValueChange={(values) => {
                          this.setState({
                            shebaValue: values.value,
                          });
                        }}
                        value={this.state.shebaValue}
                        disabled={!this.state.onlinePayment}
                      />
                    </div>
                  </div>
                </div>

                <div
                  style={{
                    width: "100%",
                    maxWidth: "250px",
                    marginTop: "40px",
                    alignSelf: "center",
                  }}
                >
                  <CustomButton
                    title="تایید و ذخیره"
                    imgHeight={20}
                    imgWidth={25}
                    minHeight="35px"
                    img={Tick}
                    loading={this.state.financeLoading}
                    onClick={this.onSaveFinance.bind(this)}
                  />
                </div>
              </div>
            </div>
          </div>
        )}
        {/* {!this.state.dataLoading && (
          <div
            className="reportContaner"
            style={{ marginBottom: "100px", height: "unset" }}
          >
            <div className="reportTitleBar">اطلاعات حساب و پرداخت آنلاین</div>
            <div
              className="reportContent"
              style={{ paddingTop: "10px", paddingBottom: "10px" }}
            >
              <div
                className="pageContents"
                style={{ marginTop: "0px", height: "auto" }}
                ref={this.tableContainer}
              >
                <div className="grid-setting">
                  <div
                    className="settingItemContainer"
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      height: "54px",
                    }}
                  >
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "row",
                        width: "100%",
                        justifyContent: "space-between",
                        alignItems: "center",
                      }}
                    >
                      <div className="settingLabel">پرداخت آنلاین</div>
                      <BootstrapSwitchButton
                        checked={this.state.onlinePayment}
                        onChange={(checked) => {
                          this.setState({ onlinePayment: checked });
                        }}
                        onlabel="فعال"
                        offlabel="غیرفعال"
                        onstyle="primary"
                        offstyle="warning"
                        width={75}
                      />
                    </div>
                  </div>

                  <div
                    className="settingItemContainer"
                    style={{ display: "flex", flexDirection: "column" }}
                  >
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "row",
                        width: "100%",
                        justifyContent: "space-between",
                        alignItems: "center",
                      }}
                    >
                      <div
                        className="settingLabel"
                        style={{ fontSize: "12px" }}
                      >
                        شماره شبا
                      </div>
                      <PatternFormat
                        format="IR ## #### #### #### #### #### ##"
                        allowEmptyFormatting
                        className={
                          this.state.shebaErrorText !== ""
                            ? "inputStyleForm inputError form-control textAlignLeft"
                            : "form-control inputStyleForm textAlignLeft"
                        }
                        style={{
                          maxWidth: "300px",
                          direction: "ltr",
                        }}
                        onValueChange={(values) => {
                          this.setState({
                            shebaValue: values.value,
                          });
                        }}
                        value={this.state.shebaValue}
                        disabled={!this.state.onlinePayment}
                      />
                    </div>
                  </div>

                  <div
                    style={{
                      width: "100%",
                      maxWidth: "250px",
                      // marginTop: "40px",
                      alignSelf: "center",
                    }}
                  >
                    <CustomButton
                      title="تایید و ذخیره"
                      imgHeight={20}
                      imgWidth={25}
                      minHeight="35px"
                      img={Tick}
                      loading={this.state.financeLoading}
                      onClick={this.onSaveFinance.bind(this)}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        )} */}

        {this.state.dataLoading && (
          <div
            style={{
              position: "fixed",
              left: "0",
              TOP: "0",
              display: "flex",
              width: "100%",
              height: "100vh",
              justifyContent: "center",
              alignItems: "center",
              // backgroundColor: "red",
            }}
          >
            <WhisperSpinner
              size={50}
              color="var(--brown1)"
              frontColor="var(--brown1)"
              backColor="var(--brown1)"
              loading={true}
            />
          </div>
        )}

        <Modal
          show={this.state.ModalShow2}
          animation={true}
          size="md"
          backdrop="static"
          backdropClassName="backdropClassName"
          onHide={() => {
            this.setState({ ModalShow2: false });
          }}
          centered
        >
          {this.state.ModalShow2 && (
            <ListViewer
              withPrice={!this.state.currentListTypeIsTax}
              withPercent={this.state.currentListTypeIsTax}
              groups={this.state.currentListTypeIsTax}
              currentSelected={
                this.state.currentListTypeIsTax
                  ? this.state.taxSelected
                  : this.state.packingSelected
              }
              list={this.state.currentList}
              loading={this.state.listLoading}
              listType="product"
              onConfirmProduct={this.onConfirmProduct.bind(this)}
              // onConfirmGroups={this.onConfirmGroups.bind(this)}
              hideModal={() => {
                this.setState({ ModalShow2: false });
              }}
              defaultLangId={this.state.defaultLangId}
              rtlPriceTitle={this.state.rtlPriceTitle}
              totalMenuCount={this.state.totalMenuCount}
            />
          )}
        </Modal>

        <Modal
          show={this.state.printerModal}
          animation={true}
          size="sm"
          // backdrop="static"
          // backdropClassName="backdropClassName"
          onHide={() => {
            this.setState({ printerModal: false });
          }}
          centered
        >
          <div
            style={{
              width: "100%",
              display: "flex",
              flexDirection: "column",
              justifyContent: "flex-start",
              alignItems: "center",
              maxHeight: "400px",
              overflow: "auto",
              padding: "10px 5px",
            }}
          >
            {this.state.printerHelperAddress && (
              <a
                style={{
                  flex: "1",
                  width: "100%",
                  textAlign: "right",
                  marginBottom: "15px",
                  color: "var(--brown1)",
                  fontSize: "14px",
                  cursor: "pointer",
                  display: "flex",
                  flexDirection: "row",
                  gap: "5px",
                  alignItems: "center",
                }}
                href={
                  "https://api.sepandplus.ontco.com/api/public" +
                  this.state.printerHelperAddress
                }
                target="_blank"
              >
                <Icon
                  icon="material-symbols:download-sharp"
                  width="24"
                  height="24"
                  // style={{ color: "var(--black1)" }}
                />
                دانلود سرویس پرینت ویندوز
              </a>
            )}
            {!this.state.getPrintersLoading && (
              <div style={{ flex: "1", width: "100%" }}>
                <CustomButton
                  title="بروزرسانی لیست دستگاهای چاپ از سیستم"
                  // imgHeight={20}
                  // imgWidth={25}
                  minHeight="35px"
                  width="100%"
                  // img={Tick}
                  loading={this.state.retrievePrinterListLoading}
                  onClick={this.retrievePrinterList.bind(this)}
                />
              </div>
            )}

            {!this.state.getPrintersLoading && (
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "flex-start",
                  maxHeight: "300px",
                  overflow: "auto",
                  padding: "0px 5px",
                  width: "100%",
                  minHeight: "120px",
                  border: "2px solid var(--black1)",
                  borderRadius: "10px",
                  marginTop: "10px",
                }}
              >
                {!this.state.retrievePrinterListLoading &&
                  this.state.allPrinterList.map((item, i) => {
                    return (
                      <PrinterItem
                        key={i}
                        item={item}
                        changeSelect={this.changePrinterSelect.bind(this)}
                        changeLabel={this.changePrinterLabel.bind(this)}
                        setForCashier={this.setPrinterForCashier.bind(this)}
                      />
                    );
                  })}
                {!this.state.retrievePrinterListLoading &&
                  this.state.allPrinterList.length < 1 && (
                    <div
                      style={{
                        width: "100%",
                        minHeight: "100px",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                      }}
                    >
                      هیچ دستگاه چاپی یافت نشد
                    </div>
                  )}
                {this.state.retrievePrinterListLoading && (
                  <div
                    style={{
                      width: "100%",
                      minHeight: "100px",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                  >
                    <WhisperSpinner
                      size={26}
                      color="var(--brown1)"
                      frontColor="var(--brown1)"
                      backColor="var(--brown1)"
                      loading={true}
                    />
                  </div>
                )}
              </div>
            )}

            {this.state.getPrintersLoading && (
              <div
                style={{
                  width: "100%",
                  minHeight: "100px",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <WhisperSpinner
                  size={30}
                  color="var(--brown1)"
                  frontColor="var(--brown1)"
                  backColor="var(--brown1)"
                  loading={true}
                />
              </div>
            )}

            <div
              style={{
                width: "100%",
                display: "flex",
                flexDirection: "row",
                justifyContent: "space-between",
                marginTop: "20px",
                alignItems: "center",
                gap: "10px",
              }}
            >
              <div style={{ flex: "1" }}>
                <CustomButton
                  title="تایید"
                  imgHeight={20}
                  imgWidth={25}
                  minHeight="35px"
                  img={Tick}
                  loading={this.state.buttonLoading}
                  disable={
                    this.state.retrievePrinterListLoading ||
                    this.state.getPrintersLoading
                  }
                  onClick={this.onConfirmPrinters.bind(this)}
                />
              </div>
              <div style={{ flex: "0.8" }}>
                <CustomButton
                  title="انصراف"
                  imgHeight={19}
                  backColor="var(--black1)"
                  imgWidth={25}
                  minHeight="35px"
                  disabled={
                    this.state.retrievePrinterListLoading ||
                    this.state.getPrintersLoading ||
                    this.state.buttonLoading
                  }
                  img={Cancel}
                  onClick={() => {
                    this.setState({ printerModal: false });
                  }}
                />
              </div>
            </div>
          </div>
        </Modal>
      </div>
    );
  }
}
